// Core i18n
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import 'moment/locale/pt-br';

// Translation files
// eslint-disable-next-line camelcase
import en_US from './en_US.json';
// eslint-disable-next-line camelcase
import pt_BR from './pt_BR.json';
// eslint-disable-next-line camelcase
import es_ES from './es_ES.json';

// All languages
const resources = {
  en_US: { translation: en_US },
  pt_BR: { translation: pt_BR },
  es_ES: { translation: es_ES },
};

export const langMap = {
  en_us: 'en_US',
  en: 'en_US',
  es_es: 'es_ES',
  es: 'es_ES',
  pt_br: 'pt_BR',
  pt: 'pt_BR',
};

export const fallbackLanguage = 'en_US';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: fallbackLanguage,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
